import { Http, http } from "../http";
import moment from "moment/moment";

export interface MassTransferFile {
    status : string,
    data : {
        fileDetailsList: [
            {
                fileBase64 : string;
                pmtid : string;
                fileName : string;
                mimeType : string;
            }
        ];
    }
    
};


export const getFileByPmid = async (language:any,pmtid: string): Promise<MassTransferFile> => {
    const httpNew = new Http(language)
    const { data } = await httpNew.get<MassTransferFile>(`file/get-payment-order-pdf?ibankRef=${pmtid}`);
    return data;
};

export const getPaymentOrderPdfByIbanRef = async (language:any,ibankref: string): Promise<MassTransferFile> => {
    const httpNew = new Http(language)
    const { data } = await httpNew.get<MassTransferFile>(`file/get-payment-order-pdf?ibankRef=${ibankref}`);
    return data;
};

// export const getAllFilesOrderAdocByIbanRef = async (language:any,ibankref: string): Promise<MassTransferFile> => {
//     const httpNew = new Http(language)
//     const { data } = await httpNew.get<MassTransferFile>(`file/getAllFilesByIbankref/${ibankref}`);
//     return data;
// };

export const getPaymentByPackageNumber = async (language:any,packagenumber:any): Promise<any> =>{
    const httpNew = new Http(language)
    const { data } = await httpNew.get<any>(`batch/get-payment-by-packagenumber/${packagenumber}`)
    return data;
}

export const checkTransferData = async (language:any,req:any): Promise<any> =>{
    const httpNew = new Http(language)
    const { data } = await httpNew.post<any>('batch/check-payment-async',req)
    return data
}

export const uploadPayment = async (language:any,req:any) : Promise<any> =>{
    const httpNew = new Http(language)
    const { data }  = await httpNew.post<any>(`batch/upload-payment`,req)
    return data
}

export const createPayment = async (language:any,req:any) : Promise<any> =>{
    const httpNew = new Http(language)
    const { data }  = await httpNew.post<any>(`batch/create-payment`,req)
    return data
}

export const deletePayment = async (language:any,req:any) : Promise<any> =>{
    const httpNew = new Http(language)
    const { data }  = await httpNew.post<any>('batch/delete-payment',req)
    return data
}


export const getBatchPaymentsData = async (language:any,start_Date,end_Date,fromBranch,batchName,trn_type,status_option): Promise<any> =>{
    const httpNew = new Http(language)
    let startDate =start_Date ? moment(start_Date).format("DD.MM.YYYY") : moment(new Date()).format("DD.MM.YYYY")
    let endDate = end_Date ? moment(end_Date).format("DD.MM.YYYY"):moment(new Date()).format("DD.MM.YYYY")
    const body = {
        pstart_date: startDate,
        pend_date: endDate,
        ...(status_option ? { pbatch_status: status_option } : {}),
        ...(batchName ? { pbatch_name: batchName } : {}),
        ...(fromBranch ? { paccount_no: fromBranch } : {}),
        ...(trn_type?.length > 0 ? { ptrn_type: trn_type } : {}),
    };






    const { data } = await httpNew.post<any>(`batch/get-payment-by-filter`, body)
    return data
}
